export const WEBSITE = {
    DOMAIN : 'www.savingsstorms.com'
}